export default __webpack_public_path__ + "static/media/after@3x.5c56e155.png";